export default __webpack_public_path__ + "static/media/Foyth.8da75e34.jpg";